import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Input,
  FormControl,
  Text,
  Flex,
  Image,
  useBreakpointValue,
  useColorModeValue,
  useColorMode,
} from "@chakra-ui/react";
import Swal from "sweetalert2";
import logo from "../../assets/img/logo_speech.png";
import outstand from "../../assets/img/logo_outstand.png";

function PasswordRecovery() {
  const { toggleColorMode } = useColorMode();
  const history = useHistory();
  const [codigo, setCodigo] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const currentColorMode = localStorage.getItem("chakra-ui-color-mode");
    if (!currentColorMode) {
      toggleColorMode();
      localStorage.setItem("chakra-ui-color-mode", "dark");
    }
  }, [toggleColorMode]);

  const showToast = (icon, title) => {
    Swal.fire({
      icon,
      title,
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  };

  const handleInsertCodigo = async () => {
    if (!codigo) {
      showToast("error", "Insira o Código");
      return;
    }
  
    const publicCode = localStorage.getItem('public_code');
    if (!publicCode) {
      showToast("error", "Erro: Public Code não encontrado.");
      return;
    }
  
    localStorage.setItem('codigo', codigo);
    localStorage.setItem('publicCode', publicCode);

    console.log("Código:", codigo);
    console.log("Public Code:", publicCode);

    const url = `https://app.customervoice.com.br/api/v1/users_page/forgot/validate?public_code=${publicCode}&code=${codigo}`;
    //const url = `https://app.customervoice.com.br/api/v1/users_page/forgot/validate?public_code=806671957}&code=7354`;

    try {
      const res = await get(url, {
        headers: {
          'Content-Type': ''
        }
      });
      console.log('DEU CERTO');
      history.push("/insertNewPassword");
    } catch (error) {
      history.push("/insertNewPassword");
      console.log('Erro ', error);
    }
  

  };
  
  

  const showVideo = useBreakpointValue({ base: false, md: true });
  const backgroundColor = useColorModeValue("white", "black");

  return (
    <Flex h="100vh" direction={{ base: "column", md: "row" }}>
      {showVideo && (
        <Box flex="1" position="relative" overflow="hidden">
          <video
            autoPlay
            loop
            muted
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: "0.7",
            }}
          >
            <source
              src={require("../../assets/movies/login_video.webm")}
              type="video/mp4"
            />
            Seu navegador não suporta a tag de vídeo.
          </video>
          <Image
            src={outstand}
            alt="Company Name"
            position="absolute"
            top="100px"
            left="130px"
            boxSize="650px"
            objectFit="contain"
            style={{
              filter:
                "drop-shadow(4px 2px 0px white) drop-shadow(2px 2px 2px gray)",
            }}
          />
        </Box>
      )}

      <Flex
        flex="1"
        align="center"
        justify="center"
        bg={backgroundColor}
        color={useColorModeValue("black", "white")}
        p="10"
      >
        <Box maxW="400px" w="100%" textAlign="center">
          <Image
            src={logo}
            alt="Customer Voice Logo"
            mx="auto"
            mb="4"
            boxSize="150px"
            objectFit="contain"
            style={{
              filter:
                "drop-shadow(4px 2px 1px) drop-shadow(4px 2px 1px black)",
            }}
          />

          <Text fontSize="xl" fontWeight="bold" mb="4">
            Insira o Código
          </Text>
          <FormControl>
            <Input
              type="text"
              placeholder="Código"
              mb="2"
              size="md"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              bg="gray.800"
              color="white"
              _placeholder={{ color: "gray.400" }}
              id="code"
            />
            <Button
              colorScheme="blue"
              size="md"
              w="full"
              onClick={handleInsertCodigo}
              mt="4"
              isLoading={isLoading}
            >
              Prosseguir
            </Button>

            <Button
              colorScheme="blue"
              size="md"
              w="full"
              mt="2"
              onClick={() => history.push("/login")}
            >
              Voltar Login
            </Button>
          </FormControl>
        </Box>
      </Flex>
    </Flex>
  );
}

export default PasswordRecovery;
